// extracted by mini-css-extract-plugin
export default {"app":"app__2SoMV","text-center":"text-center__a3oEU","error-color":"error-color__Lvw5t","loading":"loading__tZx5L","wrapper":"wrapper__lWieQ","numbers":"numbers__iGkYR"};